import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

const LoaderComponent = () => (
    <>
        <FormattedMessage id="Default.loading">
            {value => <p className="d-flex align-items-center"><FontAwesomeIcon icon={['fa', 'fa-spinner']} spin className="mr-1" /> <span>{value}</span></p>}
        </FormattedMessage>

    </>
)
export default LoaderComponent;
